import { render } from "./FunnelChart.vue?vue&type=template&id=3644eaba&scoped=true"
import script from "./FunnelChart.vue?vue&type=script&lang=js"
export * from "./FunnelChart.vue?vue&type=script&lang=js"

import "./FunnelChart.vue?vue&type=style&index=0&id=3644eaba&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3644eaba"]])

export default __exports__